import { Calendar, Clock8 } from "lucide-react";
import React, { useState } from "react";
import ImagePreview from "../ui/ImagePreview";

const Card = ({
  title,
  orders,
  varient = "card",
  date,
  description,
  galImg,
  imagUp = false,
  onViewPlan,
  selectedPlan = false,
}) => {
  // 👉 Subscribe card
  if (varient === "subscribe") {
    return (
      <div
        className={`max-w-full rounded-xl p-4 cursor-pointer relative
        ${
          selectedPlan
            ? "ring-2 ring-orange-400 bg-[#FFEFEB]"
            : "bg-gray-100 border border-gray-100"
        }`}
      >
        {/* ✅ Tick mark on top left when active */}
        {selectedPlan && (
          <div className="absolute -top-2 -left-2 bg-orange-500 text-white w-5 h-5 flex items-center justify-center rounded-full text-xs font-bold">
            ✓
          </div>
        )}

        <div className="flex justify-between gap-4">
          <div className="flex flex-col justify-start">
            <h1 className="text-black text-start font-bold text-base">
              {title}
            </h1>
            <h2 className="font-semibold text-orange-500 text-base">
              ${orders}
            </h2>
          </div>
          <div>
            <button
              className="bg-transparent border border-[#FF6943] rounded-full text-sm w-auto px-3 py-1 cursor-pointer text-[#FF6943]"
              onClick={onViewPlan}
            >
              View plan
            </button>
          </div>
        </div>
      </div>
    );
  }
  if (varient === "growth") {
    return (
      <div
        className={`relative  max-w-md rounded-xl p-4 cursor-pointer bg-gray-100 border border-gray-100`}
      >
        <div className="flex justify-between gap-4 ">
          <div className="flex flex-col justify-start space-y-4">
            <h1 className="text-black text-start font-bold text-base">
              {title}
            </h1>
            <p className="text-start text-[#959595] text-sm flex gap-2">
              <Calendar size={20} />
              <span>{date}</span>
            </p>
          </div>
          <div className="flex flex-col space-y-4">
            <p className="bg-[#E1F4EA]  rounded-full text-sm w-auto px-3 py-1 cursor-pointer text-[#29B067]">
              success
            </p>
            <h2 className="font-semibold text-black text-base">${orders}</h2>
          </div>
        </div>
      </div>
    );
  }
  if (varient === "queries") {
    return (
      <div
        className={`relative  max-w-md rounded-xl p-4 cursor-pointer bg-gray-100 border border-gray-100`}
      >
        <div className="flex justify-between gap-4 ">
          <div className="flex flex-col  space-y-4">
            <h1 className="text-black text-start font-bold text-base">
              {title}
            </h1>
            <p className="text-xs md:text-[15px] text-[#202020] text-start">
              {description}
            </p>
          </div>
          <div>
            {imagUp && (
              <div className="border border-gray-200 p-2 rounded-md">
                <ImagePreview
                  src={galImg}
                  alt="galImg"
                  className="h-10 w-10 object-cover rounded-md"
                />
              </div>
            )}
          </div>
        </div>
        <div className="flex justify-between gap-4 mt-4">
          <p className="text-start text-[#959595] text-sm flex gap-2">
            <Clock8 size={20} />
            <span>{date}</span>
          </p>
        </div>
      </div>
    );
  }

  // 👉 Default card
  return (
    <div className="border border-[#FFDFD6] bg-[#FFF7F5] max-w-sm rounded-xl p-4 flex flex-col justify-start">
      <h1 className="text-black text-center text-[12px] font-medium md:text-base">
        {title}
      </h1>

      <div className="border-t border-[#FFCCBF] my-2 border-opacity-30" />

      <h2 className="font-semibold text-black text-[12px] font-medium md:text-base text-center">
        {orders}
      </h2>
    </div>
  );
};

export default Card;
